<script>
import config from '../../common/genericPanelConf';
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import CommonService from '../../services/common';
import Service from '../../services/operative-plan';

import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";


import TabView from 'primevue/tabview'; 
import TabPanel from 'primevue/tabpanel';
import Dialog from 'primevue/dialog';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import GenericDataTable from '../generic/GenericDataTable.vue'
import GenericCustomAutocompleteV2 from '../generic/GenericCustomAutocompleteV2.vue'
import GenericCustomMasterDataAutocompleteV2 from '../generic/GenericCustomMasterDataAutocompleteV2.vue' 
import ResponsiveButton from '../generic/ResponsiveButton.vue'
import EquipmentDialog from './EquipmentDialog.vue';
import GenericBooleanDropdown from '../generic/GenericBooleanDropdown.vue';

export default {
    emit: ['showSchedulingAttachmentsDialog'],
    setup: () => ({ v$: useVuelidate() }),
    components: {
        TabView, TabPanel,
        Calendar, InputNumber,InputText,
        GenericCustomAutocompleteV2, ResponsiveButton, GenericCustomMasterDataAutocompleteV2,
        GenericDataTable,
        Dialog, EquipmentDialog,
        GenericBooleanDropdown 
    },
    created(){
           let sentToDailyPlan = [{ name: 'sentToDailyPlan', label: 'operativePlan.sentToDailyPlan', type: 'boolean', readOnly: true}];
        this.originalConf = config.getConfiguration('OperativePlanScheduled');
        this.configuration = { ...this.originalConf};

        this.configuration.columns = sentToDailyPlan.concat(this.configuration.columns)

        this.configuration.api = 'operative-plan/scheduled-operation-daily-planning';

        this.originalConfEquipment = config.getConfiguration('ScheduledEquipmentOperation');
        this.configurationEquipment = { ...this.originalConfEquipment};
    },
    mounted(){
        this.loadFromCache();
    },
    data(){
        return{
            originalConf: {},
            submitted: false,
            configuration: {},
            filters: {
                dailyPlanDate: Utils.formatDatePlusDays(new Date(), 0),
                plantId: CommonConstants.defaultPlantId
            },
            equipmentDialog: {
                visible: false,
                record: null
            },
            equipmentOperationDialog: {
                visible: false,
                record: null
            },
            platformDialog: {
                visible: false,
                record: null
            },
            originalConfEquipment: {},
            configurationEquipment: {},

            createEquipmentOperationSubmitted: false,
            createEquipmentOperationDialogVisible: false,
            createEquipmentOperationDisabled: false,
            newEquipmentOperation: {
                scheduledOperationDate: null,
                idRegistryPlant: null,
                idRegistryOperationType: null, 
                idRegistryOperationTypeClass : null,
                idEquipmentOperationTank : null,
                idRegistryProduct : null,
                equipmentOperationQty : null,
                idRegistryCompanyOwner : null,
                notes : null,
                atk : null,
                atb : null,
                denaturingFlag : null
            },
            showHidden: false
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
    },
     watch: {
        'filters.plantId'(newValue){
            this.$emit('onPlantChanged', newValue);
        }
    },
    validations(){
        return {
            filters: {
                dailyPlanDate: {required},
                plantId: {}
            },
            newEquipmentOperation: {
                scheduledOperationDate: {required},
                idRegistryPlant: {required},
                idRegistryOperationType: {required}, 
                idRegistryOperationTypeClass : {},
                idEquipmentOperationTank : {required},
                idRegistryProduct : {required},
                equipmentOperationQty : {},
                idRegistryCompanyOwner : {},
                notes : {},
                atk : {},
                atb : {},
                denaturingFlag : {}
            }
        }
    },
    methods: {
        load(valid){
            this.submitted = true;
            if(valid || !this.v$.filters.$invalid){
                let filters = {
                    dailyPlanDate: Utils.formatDateForAPIWithTime(this.filters.dailyPlanDate),
                    plantId: this.filters.plantId
                }
                this.$refs.operativePlanGrid.filterFromView(filters, true);

                
                let eqFilters = {
                    dailyPlanDate: Utils.formatDateForAPIWithTime(this.filters.dailyPlanDate),
                    plantId: this.filters.plantId
                }
                this.$refs.scheduledEquipmentOperationGrid.filterFromView(eqFilters, true);

                
                this.saveCache();
            }
        },
        onDialogEditSave(item, originalItem){
            let showAlert = false;
            if(item.mooringDate != null){
                showAlert = new Date(item.mooringDate) < new Date(item.laycanStartDate);
                if(item.unmooringDate != null){
                    if(new Date(item.mooringDate) > new Date(item.unmooringDate)){
                        this.$toast.add({detail: this.$t('operativePlan.errorMooringDateAfterUnmooringDate'), life:3000, severity:'error'});
                        return;
                    }
                }
            }
            if(showAlert){
                this.$confirm.require({
                    message: this.$t('operativePlan.alertMooringDateBeforeLaycanStart'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => {
                        this.performDialogEditSave(item, originalItem);
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                        this.$confirm.close();
                    }
                });
            }else{
                this.performDialogEditSave(item, originalItem);
            }
        },
        performDialogEditSave(item, originalItem){

            let upd = false;
            let toUpdate = {
                id: item.id
            };

            if(item.scheduledOperationDate != originalItem.scheduledOperationDate){
                upd = true;
                toUpdate.scheduledOperationDate = item.scheduledOperationDate
                toUpdate.scheduledOperationDateUpdated = true;
            }

            if(item.etaDate != originalItem.etaDate){
                upd = true;
                toUpdate.etaDate = item.etaDate
                toUpdate.etaDateUpdated = true;
            }

            if(item.mooringDate != originalItem.mooringDate){
                upd = true;
                toUpdate.mooringDate = item.mooringDate
                toUpdate.mooringDateUpdated = true;
            }

            if(item.unmooringDate != originalItem.unmooringDate){
                upd = true;
                toUpdate.unmooringDate = item.unmooringDate
                toUpdate.unmooringDateUpdated = true;
            }

            if(item.idMooringPlatform != originalItem.idMooringPlatform){
                upd = true;
                toUpdate.idMooringPlatform = item.idMooringPlatform
                toUpdate.idMooringPlatformUpdated = true;
            }

            if(item.notes != originalItem.notes){
                upd = true;
                toUpdate.notes = item.notes
                toUpdate.notesUpdated = true;
            }

            if(item.noteScheduling != originalItem.noteScheduling){
                upd = true;              
            }

            toUpdate.noteScheduling = item.noteScheduling

            if(item.isHidden != originalItem.isHidden){
                upd = true;
                toUpdate.isHidden = item.isHidden
                toUpdate.isHiddenUpdated = true;
            }

            if(item.isVesselInRoadstead != originalItem.isVesselInRoadstead){
                upd = true;
                toUpdate.isVesselInRoadstead = item.isVesselInRoadstead
                toUpdate.isVesselInRoadsteadUpdated = true;
            }


            if(item.idRegistryShippingAgency != originalItem.idRegistryShippingAgency){
                upd = true;
                toUpdate.idRegistryShippingAgency = item.idRegistryShippingAgency
                toUpdate.idRegistryShippingAgencyUpdated = true;
            }
            if(upd){
                CommonService.updateItem(this.originalConf.updateApi, toUpdate, response => {
                    if(response.success){
                        this.$refs.operativePlanGrid.hideDialogEdit();
                        this.load(true);
                        if(response.message){
                            this.$toast.add({detail: response.message , life:3000, severity: 'warn'});
                        }
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
            }

        },
        onCellEditComplete(event){
            let originalData = event.data;
            let newData = event.newData;

            let oldValue = originalData[event.field];
            let newValue = newData[event.field];
            let upd = oldValue != newValue;

            let fieldName = event.field;
            let fieldNameUpd = event.field + 'Updated';

            switch(event.field){
                case 'etaDate':
                case 'laycanStartDate':
                case 'laycanEndDate':
                case 'mooringDate':
                case 'unmooringDate':
                case  'scheduledOperationDate':
                    if(originalData[event.field] != null){
                        oldValue = new Date(Utils.dateToCurrentTimeZone(originalData[event.field]));
                    }
                    upd = !Utils.dateEquals(oldValue, newValue);
                break;
                case 'mooringPlatform':
                    newValue = newData['idMooringPlatform'];
                    upd = oldValue != newValue;

                    fieldName = 'idMooringPlatform';
                    fieldNameUpd = 'idMooringPlatformUpdated';
                    break;
            }
            if(upd){
                let toUpdate = {
                    id: newData.id,
                };
                toUpdate[fieldName] = newData[fieldName];
                toUpdate[fieldNameUpd] = true;
                CommonService.updateItem(this.originalConf.updateApi, toUpdate, response => {
                    if(response.success){
                        this.load(true);
                        if(response.message){
                            this.$toast.add({detail: response.message , life:3000, severity: 'warn'});
                        }
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
            }
        },
        onCellEquipmentEditComplete(event){
            let newData = event.newData;
            Service.saveScheduledEquipmentOperation(newData, response => {
                    if(response.success){
                        this.load(true);
                        if(response.message){
                            this.$toast.add({detail: response.message , life:3000, severity: 'warn'});
                        }
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
        },
        onEquipmentDialogEditSave(newData){
            Service.saveScheduledEquipmentOperation(newData, response => {
                if(response.success){
                    this.$refs.scheduledEquipmentOperationGrid.hideDialogEdit();
                    this.load(true);
                    if(response.message){
                        this.$toast.add({detail: response.message , life:3000, severity: 'warn'});
                    }
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        showEquipmentDialog(record){
            this.equipmentDialog = {
                visible: true,
                idRegistryPlant: record.idRegistryPlant
            };
            this.$refs.equipmentDialog.loadEquipmentLayout(record.id, false, record.equipmentOperationTank);
            this.$refs.equipmentDialog.show();
        },
        showEquipmentOperationDialog(record){
            this.equipmentOperationDialog = {
                visible: true,
                idRegistryPlant: record.registryOperationType == 'TRV'  ? '': record.idRegistryPlant
            };
            this.$refs.equipmentOperationDialog.loadEquipmentLayout(record.id, true, record.equipmentOperationTank);
            this.$refs.equipmentOperationDialog.show();
        },
        createEquipmentOperation(){
            this.createEquipmentOperationSubmitted = true;
            if(!this.v$.newEquipmentOperation.$invalid){
                this.createEquipmentOperationDisabled = true;

                Service.createScheduledEquipmentOperation(this.newEquipmentOperation, response => {
                    this.createEquipmentOperationSubmitted = false;
                    this.createEquipmentOperationDisabled = false;
                    if(response.success){
                        this.load(true);
                        this.createEquipmentOperationDialogVisible = false;
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }
        },
        copyInTomorrowPlan(data){

            this.newEquipmentOperation = {
                id: null,
                // scheduledOperationDate: Utils.formatDatePlusDays(new Date(), 1),
                scheduledOperationDate: Utils.formatDatePlusDaysSameTime(new Date(Utils.dateToUTC(data.scheduledOperationDate)), 1),
                idRegistryPlant: data.idRegistryPlant,
                idRegistryOperationType: data.idRegistryOperationType, 
                idRegistryOperationTypeClass : data.idRegistryOperationTypeClass,
                idEquipmentOperationTank : data.idEquipmentOperationTank,
                idRegistryProduct : data.idRegistryProduct,
                equipmentOperationQty : data.equipmentOperationQty,
                idRegistryCompanyOwner : data.idRegistryCompanyOwner,
                notes : null,
                atk : data.atk,
                atb : data.atb,
                denaturingFlag : data.denaturingFlag
            };
            this.$confirm.require({
                group: 'copyOperationConfirmDialog',
                message: this.$t('operativePlan.copyInTomorrowPlanMsg'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.performCopy(data.id);
                    // caller.copyInTomorrowPlan(record);
                    // caller.$emit('copyInTomorrowPlan', record);
                    // caller.$confirm.close();

                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        performCopy(oldId){
            this.$store.dispatch("generic/setLoading", true);
            Service.copyScheduledEquipmentOperation(oldId, this.newEquipmentOperation, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.load(true);
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        onAddMovementInstruction(){
            //let uri = `/movement-instruction/0`;
            this.$router.push(`/movement-instruction/0`);
        },
        sendOperations(){

            this.$confirm.require({
                message: this.$t('operativePlan.sendMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$confirm.close();
                    // let operativePlanData = this.$refs.operativePlanGrid.data;
                    // let scheduledEquipmentOperationData = this.$refs.scheduledEquipmentOperationGrid.data;

                    let body = {
                        planDate: Utils.formatDateForAPI(this.filters.dailyPlanDate),
                        searchDate: this.filters.dailyPlanDate,
                        idRegistryPlant: this.filters.plantId,
                        scheduledOperationIdsList: []
                    }
                    // let data = [];
                    // for(let i=0; i<operativePlanData.length; i++){
                    //     if(!operativePlanData[i].isMovementInstructionLotDeleted){
                    //         body.scheduledOperationIdsList.push(operativePlanData[i].id);
                    //     }
                    // }
                    // for(let i=0; i<scheduledEquipmentOperationData.length; i++){
                    //     body.scheduledOperationIdsList.push(scheduledEquipmentOperationData[i].id);
                    // }

                    Service.sendPlan(body, response =>{
                         if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('operativePlan.sendMessageSuccess'), life: 3000});
                            this.load(true)
                        }
                        else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    });

                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        printPdf(){
            let params = {
                dailyPlanDate: Utils.formatDateForAPI(this.filters.dailyPlanDate),
                plantId: this.filters.plantId
            };
            this.$store.dispatch("generic/setLoading", true);
            Service.printDailyPlanningSheet(params, response => {
                
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'DailyPlanningSheet.pdf');
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        onDialogPlantSelected(event){
            let plantId = event.value;

            // record.registryOperationType == 'TRV'

            let tankApi = `masterdata/equipment-combo?getOnlyValid=true&type=SERB&plantId=${plantId}`;
            this.$refs.dialogTankSelect.loadOptions(tankApi);
        },

        onDialogOperationTypeSelected(event){
            console.log(event)
            if(event.valueString == 'TRV'){
                let tankApi = `masterdata/equipment-combo?getOnlyValid=true&type=SERB`;
                this.$refs.dialogTankSelect.loadOptions(tankApi);
            }else{
                let tankApi = `masterdata/equipment-combo?getOnlyValid=true&type=SERB&plantId=${this.newEquipmentOperation.idRegistryPlant}`;
                this.$refs.dialogTankSelect.loadOptions(tankApi);
            }
        },
        openCreateEquipmentOperationDialog(){
            this.newEquipmentOperation = {
                scheduledOperationDate: Utils.formatDatePlusDays(this.filters.dailyPlanDate, 0),
                idRegistryPlant: this.filters.plantId,
                idRegistryOperationType: null, 
                idRegistryOperationTypeClass : null,
                idEquipmentOperationTank : null,
                idRegistryProduct : null,
                equipmentOperationQty : null,
                idRegistryCompanyOwner : null,
                notes : null,
                atk : null,
                atb : null,
                denaturingFlag : null
            }
            this.createEquipmentOperationDialogVisible=true

            // let plantId = this.filters.plantId;

            // let tankApi = `masterdata/equipment-combo?getOnlyValid=true&type=SERB&plantId=${plantId}`;
            // this.$refs.dialogTankSelect.loadOptions(tankApi);

        },
        viewReport() {
            let params = {
                dailyPlanDate: Utils.formatDateForAPI(this.filters.dailyPlanDate),
                plantId: this.filters.plantId
            };
            this.$store.dispatch("generic/setLoading", true);
            Service.getDailyPlanReportData(params, response => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    const dati = response.data
                    localStorage.setItem('dailyPlanReport', JSON.stringify(dati));
                    window.open('daily-plan-report');
                } else {
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        setPlant(plantId){
            this.filters.plantId = plantId;
        },
        plantChange(e){
            this.$emit('onPlantChanged', e.value);
        },
        loadFromCache(){
            let cacheData = this.$store.getters['cacheDataStore/getGridCache']('DailyPlanningSheetGrid');
            if(cacheData){
                this.filters.dailyPlanDate = cacheData.dailyPlanDate,
                this.filters.plantId = cacheData.plantId
            }
            
            this.load(true);
        },
        saveCache(){
            let cacheData = {
                name: 'DailyPlanningSheetGrid',
                filters: {
                    plantId: this.filters.plantId,
                    dailyPlanDate: this.filters.dailyPlanDate
                }
            };
            this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
        },
        showSchedulingAttachmentsDialog(record){
            this.$emit('showSchedulingAttachmentsDialog', record)
        }
    }
}
</script>

<template>
    <main>
        <ConfirmDialog group="copyOperationConfirmDialog">
            <template #message="slotProps">
                <div class="grid">
                    <div class="col-12">
                        <p class="pl-2">{{ slotProps.message.message }}</p>
                    </div>
                    <div class="col-12">
                        <label>{{$t('operativePlan.scheduledOperationDate')}}</label>     
                        <Calendar 
                            :class="{'w-full p-inputtext-sm mt-1 ': true}"
                            :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                            :dateFormat="constants.DATE_FORMAT_POINT"
                            :showTime="true" :hideOnDateTimeSelect="true"
                            v-model="newEquipmentOperation.scheduledOperationDate"  />
                    </div>
                </div>
            </template>
        </ConfirmDialog>

        <Dialog v-model:visible="createEquipmentOperationDialogVisible" modal class="p-fluid" :style="{width: '85vw'}">
            <div class="grid">
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.scheduledOperationDate.$invalid && createEquipmentOperationSubmitted}">{{$t('operativePlan.scheduledOperationDate')}}</label>     
                    <Calendar 
                        :class="{'p-invalid':v$.newEquipmentOperation.scheduledOperationDate.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}"
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="true" :hideOnDateTimeSelect="true"
                         v-model="newEquipmentOperation.scheduledOperationDate"  />         
                    <div v-if="(v$.newEquipmentOperation.scheduledOperationDate.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.scheduledOperationDate.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.scheduledOperationDate.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.idRegistryPlant.$invalid && createEquipmentOperationSubmitted}">{{$t('registryPlant.fk')}}</label>      
                    <GenericCustomMasterDataAutocompleteV2
                        :name="'registry-plant'"
                        :changeFn="onDialogPlantSelected"
                        v-model="newEquipmentOperation.idRegistryPlant" 
                        :api="'masterdata/registry-plant-combo'"
                        :class="{'p-invalid':v$.newEquipmentOperation.idRegistryPlant.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />        
                    <div v-if="(v$.newEquipmentOperation.idRegistryPlant.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.idRegistryPlant.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.idRegistryPlant.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.idRegistryOperationType.$invalid && createEquipmentOperationSubmitted}">{{$t('operationType.fk')}}</label>      
                    <GenericCustomMasterDataAutocompleteV2
                        :name="'registry-operation-type'"
                        :changeFn="onDialogOperationTypeSelected"
                        v-model="newEquipmentOperation.idRegistryOperationType" 
                        :api="'masterdata/operation-type-combo?tankOperationFlag=S'"
                        :class="{'p-invalid':v$.newEquipmentOperation.idRegistryOperationType.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />        
                    <div v-if="(v$.newEquipmentOperation.idRegistryOperationType.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.idRegistryOperationType.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.idRegistryOperationType.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.idRegistryOperationTypeClass.$invalid && createEquipmentOperationSubmitted}">{{$t('operationTypeClass.fk')}}</label>      
                    <GenericCustomMasterDataAutocompleteV2
                        :name="'registry-operation-type-class'"
                        v-model="newEquipmentOperation.idRegistryOperationTypeClass" 
                        :api="'masterdata/operation-type-class-combo'"
                        :class="{'p-invalid':v$.newEquipmentOperation.idRegistryOperationTypeClass.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />        
                    <div v-if="(v$.newEquipmentOperation.idRegistryOperationTypeClass.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.idRegistryOperationTypeClass.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.idRegistryOperationTypeClass.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.idEquipmentOperationTank.$invalid && createEquipmentOperationSubmitted}">{{$t('tankOperations.tank')}}</label>      
                    <GenericCustomAutocompleteV2
                        ref="dialogTankSelect"
                        :name="'registry-equipment-operation-tank'"
                        v-model="newEquipmentOperation.idEquipmentOperationTank" 
                        :api="'masterdata/equipment-combo?type=SERB&getOnlyValid=true&plantId=' + filters.plantId"
                        :format="{label: 'label', value: 'value'}"
                        :class="{'p-invalid':v$.newEquipmentOperation.idEquipmentOperationTank.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />        
                    <div v-if="(v$.newEquipmentOperation.idEquipmentOperationTank.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.idEquipmentOperationTank.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.idEquipmentOperationTank.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.idRegistryProduct.$invalid && createEquipmentOperationSubmitted}">{{$t('product.fk')}}</label>      
                    <GenericCustomMasterDataAutocompleteV2
                        :name="'registry-product'"
                        v-model="newEquipmentOperation.idRegistryProduct" 
                        :api="'masterdata/product-combo'"
                        :class="{'p-invalid':v$.newEquipmentOperation.idRegistryProduct.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />        
                    <div v-if="(v$.newEquipmentOperation.idRegistryProduct.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.idRegistryProduct.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.idRegistryProduct.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.equipmentOperationQty.$invalid && createEquipmentOperationSubmitted}">{{$t('operativePlan.quantity')}}</label>      
                    <InputNumber class="p-inputtext-sm w-full" v-model="newEquipmentOperation.equipmentOperationQty"
                        :class="{'p-invalid':v$.newEquipmentOperation.equipmentOperationQty.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.newEquipmentOperation.equipmentOperationQty.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.equipmentOperationQty.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.equipmentOperationQty.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.idRegistryCompanyOwner.$invalid && createEquipmentOperationSubmitted}">{{$t('operativePlan.company')}}</label>      
                    <GenericCustomMasterDataAutocompleteV2
                        :name="'registry-company-owner'"
                        v-model="newEquipmentOperation.idRegistryCompanyOwner" 
                        :api="'masterdata/company-combo'"
                        :class="{'p-invalid':v$.newEquipmentOperation.idRegistryCompanyOwner.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />        
                    <div v-if="(v$.newEquipmentOperation.idRegistryCompanyOwner.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.idRegistryCompanyOwner.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.idRegistryCompanyOwner.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.notes.$invalid && createEquipmentOperationSubmitted}">{{$t('operativePlan.notes')}}</label>      
                    <InputText class="p-inputtext-sm w-full" v-model="newEquipmentOperation.notes"
                        :class="{'p-invalid':v$.newEquipmentOperation.notes.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.newEquipmentOperation.notes.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.notes.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.notes.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.atk.$invalid && createEquipmentOperationSubmitted}">{{$t('ATK')}}</label>      
                    <InputNumber class="p-inputtext-sm w-full" v-model="newEquipmentOperation.atk"
                        :class="{'p-invalid':v$.newEquipmentOperation.atk.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.newEquipmentOperation.atk.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.atk.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.atk.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.atb.$invalid && createEquipmentOperationSubmitted}">{{$t('ATB')}}</label>      
                    <InputNumber class="p-inputtext-sm w-full" v-model="newEquipmentOperation.atb"
                        :class="{'p-invalid':v$.newEquipmentOperation.atb.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.newEquipmentOperation.atb.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.atb.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.atb.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                <div class="field col-12 lg:col-3">
                    <label :class="{'p-error':v$.newEquipmentOperation.denaturingFlag.$invalid && createEquipmentOperationSubmitted}">{{$t('operativePlan.denaturingFlag')}}</label>      
                        <generic-boolean-dropdown
                            v-model="newEquipmentOperation.denaturingFlag" 
                        :class="{'p-invalid':v$.newEquipmentOperation.denaturingFlag.$invalid && createEquipmentOperationSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.newEquipmentOperation.denaturingFlag.$invalid && createEquipmentOperationSubmitted) || v$.newEquipmentOperation.denaturingFlag.$pending.$response">
                        <small class="p-error" v-for="error in v$.newEquipmentOperation.denaturingFlag.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
            </div>
            <template #footer>
                <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="createEquipmentOperationDialogVisible = false"/>
                <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="createEquipmentOperation" :disabled="createEquipmentOperationDisabled" />
            </template>
        </Dialog>
        <EquipmentDialog ref="equipmentDialog" :item="equipmentDialog" :refreshGrid="load"/>
        <EquipmentDialog ref="equipmentOperationDialog" :item="equipmentOperationDialog" :refreshGrid="load"/>
        <div class="grid">
            <div class="col-12 lg:col-2 field  mt-3 mx-3">
                <label for="from" :class="{'p-error':v$.filters.dailyPlanDate.$invalid && submitted}">{{$t('operativePlan.dailyPlanDate')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.dailyPlanDate.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dailyPlanDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.dailyPlanDate.$invalid && submitted) || v$.filters.dailyPlanDate.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.dailyPlanDate.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field mt-3 mx-3">
                <label for="plant" :class="{'p-error':v$.filters.plantId.$invalid && submitted}">{{$t('registryPlant.fk')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    field="label"
                    v-model="filters.plantId"
                    api="masterdata/registry-plant-combo"
                    :addEmpty="true"
                    :emptyValue="null"
                        :name="'registry-plant'"
                    :emptyLabel="$t('all')"
                    :format="{ label: 'description', value: 'id' }"
                    :class="{'p-invalid':v$.filters.plantId.$invalid && submitted, 'p-inputtext-sm w-full': true}" />
                <div v-if="(v$.filters.plantId.$invalid && submitted) || v$.filters.plantId.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.plantId.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <!-- <div class="col-12 lg:col-1 field">
                <label >{{$t('showHidden')}}</label>
                <div>
                    <TriStateCheckbox class="p-inputtext-sm" v-model="showHidden" />
                    <span class="ml-3">{{showHidden == null ? $t('all') : (showHidden ? $t('yes'): $t('no'))}}</span>
                </div>
            </div> -->
            <div class="col-12 lg:col-7 mt-6">
                <ResponsiveButton :label="$t('btn.refresh')" icon="pi pi-replay" class="p-button-sm mx-1" @click="load(!v$.$invalid)"/>
                <ResponsiveButton :label="$t('operativePlan.addMovementInstruction')" icon="pi pi-plus" class="mx-1 p-button-outlined  p-button-sm" @click="$router.push(`/movement-instruction/0`)" :disabled="!uiPermissions('movementInstructionAddButton').isEnabled" />
                <ResponsiveButton :label="$t('btn.send')" icon="pi pi-send" class="p-button-sm mx-1" @click="sendOperations" :disabled="!uiPermissions('OperativePlan.SendOperations').isEnabled"/>
                <ResponsiveButton :label="$t('btn.print')" icon="pi pi-file-pdf" class="mx-1 p-button-outlined p-button-sm" @click="printPdf"/>
                <ResponsiveButton :label="$t('btn.view')" icon="pi pi-table" class="mx-1 p-button-outlined p-button-sm" @click="viewReport"/>
            </div>
            <div class="col-12" style="height: calc(100vh - 200px)">
                <tab-view>
                     <tab-panel :header="$t('operativePlan.movements')">
                        <div style="height: 60vh;">
                            <GenericDataTable :configuration="configuration" :category="'operative'" :name="'plan'" ref="operativePlanGrid" :onCellEditComplete="onCellEditComplete" @show-equipment-dialog="showEquipmentDialog" :onDialogEditSave="onDialogEditSave" @showSchedulingAttachmentsDialog="showSchedulingAttachmentsDialog"/>
                        </div>
                    </tab-panel>
                    <tab-panel :header="$t('operativePlan.equipments')">
                        <div style="height: 55vh;">
                        <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="p-button-sm m-1" @click="openCreateEquipmentOperationDialog" :disabled="!uiPermissions('OperativePlan.CreateOperation').isEnabled "/>
                            <GenericDataTable :configuration="configurationEquipment" :category="'equipment'" :name="'scheduled'" ref="scheduledEquipmentOperationGrid" :onCellEditComplete="onCellEquipmentEditComplete" @show-equipment-operation-dialog="showEquipmentOperationDialog"
                            :onDialogEditSave="onEquipmentDialogEditSave" @copy-in-tomorrow-plan="copyInTomorrowPlan" />
                        </div>
                    </tab-panel>
                </tab-view>
            </div>
        </div>
    </main>
</template>